/* SSCS – ouvre les formulaires Tally (candidature Master, quiz) en pop-up
   sur les pages parcours, Compose et orientation. Les paramètres de l'URL
   (?univers=…) sont transmis au formulaire comme champs cachés.
   Si le script Tally ne se charge pas, le lien s'ouvre normalement. */
(function () {
  var SCOPE = '.sscs-pp, .sscs-compose, .section-sscs-orientation';
  var loading = null;

  function loadTally() {
    if (window.Tally) return Promise.resolve(window.Tally);
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://tally.so/widgets/embed.js';
      s.async = true;
      s.onload = function () { window.Tally ? resolve(window.Tally) : reject(); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return loading;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href*="tally.so/r/"]');
    if (!link || !link.closest(SCOPE)) return;
    var url;
    try { url = new URL(link.href); } catch (err) { return; }
    var formId = url.pathname.split('/r/')[1];
    if (!formId) return;
    e.preventDefault();
    var hidden = {};
    url.searchParams.forEach(function (v, k) { hidden[k] = v; });
    hidden.page = window.location.pathname;
    loadTally().then(function (Tally) {
      Tally.openPopup(formId, { layout: 'modal', width: 640, overlay: true, hiddenFields: hidden });
    }).catch(function () {
      window.open(link.href, '_blank', 'noopener');
    });
  });
})();

/* Tableau comparatif : étiquette de formule sur chaque case (utilisée par la version mobile) */
(function () {
  document.querySelectorAll('.pp-compare').forEach(function (table) {
    var heads = Array.prototype.map.call(table.querySelectorAll('thead th'), function (th) {
      var last = th.lastChild;
      return ((last && last.nodeType === 3 ? last.textContent : th.textContent) || '').trim();
    });
    table.querySelectorAll('tbody tr, tfoot tr').forEach(function (tr) {
      Array.prototype.forEach.call(tr.children, function (cell, i) {
        if (i > 0 && heads[i]) cell.setAttribute('data-label', heads[i]);
      });
    });
  });
})();
